import { combineReducers } from "redux";
import NotificationReducer from "./reducers/notificationForWebsite/reducer";
import E_TENDER_NotificationReducer from "./reducers/Etender/reducer";
import WEBSITE_NOTIFICATIONS_NotificationReducer from "./reducers/WebsiteNotification/reducer";
import RegistrationReducer from "./reducers/Registration/reducer";

import { ALL_VIDEO_LISTreducer } from "./reducers/LatestVideoes/reducer";
import { ALL_NEWS_LISTreducer } from "./reducers/LatestNews/reducer";
import { ALL_SCHEMES_LISTreducer } from "./reducers/Scheme/reducer";
import { ALL_INSITUTION_LISTreducer } from "./reducers/InsititutionRegistration/reducer";
import { VenueReducer } from "./reducers/Booking/reducer";
import { BookingReducer } from "./reducers/Booking/reducer";
import { ALL_AWARD_LISTreducer } from "./reducers/AthleteAward/reducer";
import { loginWithOtpReducer } from "./reducers/OtpMobileVerification/reducer";
import CalanderReducer from "./reducers/CalanderEvents/reducer";
import expertiseReducer from "./reducers/Expertise/reducer";
import sessionReducer from "./reducers/Sessions/reducer";
import {TicketBookingReducer} from "./reducers/TicketBooking/reducer";

const rootReducer = combineReducers({
  NotificationReducer,
  E_TENDER_NotificationReducer,
  WEBSITE_NOTIFICATIONS_NotificationReducer,
  RegistrationReducer,
  ALL_VIDEO_LISTreducer,
  ALL_NEWS_LISTreducer,
  ALL_SCHEMES_LISTreducer,
  ALL_INSITUTION_LISTreducer,
  VenueReducer,
  TicketBookingReducer,
  BookingReducer,
  ALL_AWARD_LISTreducer,
  loginWithOtpReducer,
  CalanderReducer,
  expertise: expertiseReducer,
  sessionReducer,

});
export default rootReducer;
